import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ScreenSaver3.css';

import SplashCursor from '../Common/SplashCursor/SplashCursor';
import AppleWatchFloatingCircle from '../Common/AppleWatchFloatingCircle/AppleWatchFloatingCircle';
import StarBorder from '../Common/StarBorder/StarBorder';
import ProfileCards from '../Common/ProfileCards/ProfileCards';

const logoCoppe         = require('../../assets/logo/coppe-white.png');
const screensaverVideo  = require('../../assets/video/screensaver_red.mp4');

const ScreenSaver3 = ({ onStart }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [splashKey, setSplashKey] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => { setIsVisible(true); }, 100); 
    return () => clearTimeout(timer);
  }, []);

  // Forçar reinicialização do SplashCursor para evitar problemas de cache
  useEffect(() => {
    const timer = setTimeout(() => {
      setSplashKey(prev => prev + 1);
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  const handleStart = () => {
    setIsFadingOut(true);
    
    setTimeout(() => {
      if (onStart) {
        onStart();
      } else {
        navigate(`${process.env.PUBLIC_URL}/presentation/eor/wag/Dubai`);
      }
    }, 500); 
  };

  return (
    
    <div className={`screensaver ${isVisible ? 'fade-in' : ''} ${isFadingOut ? 'fade-out' : ''}`}>
      <div className="screensaver-background">
        <SplashCursor key={splashKey}/>
        <video 
          className="hero__video" 
          autoPlay  
          muted 
          loop  
          playsInline 
          preload="metadata"
        >
        <source src={screensaverVideo} type="video/mp4" />
        </video>
        
        {/*<div className="screensaver-overlay"></div>*/}
      
      </div>
      
      {/* Logo no canto superior esquerdo */}
      <div className="screensaver-logo-container">
        <img src={logoCoppe} alt="Logo" className="screensaver-logo" style={{width: '8rem'}} />
      </div>

      <div className="screensaver-floating-icons">
         
         <AppleWatchFloatingCircle 
             count={6}
             position='top'
             icons={[
              { name: 'Phone', icon: require('../../assets/logo/01/1.webp'), color: '#159d80', title: 'Inteligência Artificial	', iconAlreadyBackground: true },
              { name: 'Mail', icon: require('../../assets/logo/01/2.webp'), color: '#e05045', title: 'Robótica', iconAlreadyBackground: true},
              { name: 'Messages', icon: require('../../assets/logo/01/3.webp'), color: '#dfa504', title: 'Manufatura Auxiliada', iconAlreadyBackground: true},
              { name: 'Breathe', icon: require('../../assets/logo/01/4.webp'), color: '#167311', title: 'Engenharia', iconAlreadyBackground: true },
              { name: 'Breathe', icon: require('../../assets/logo/01/5.webp'), color: '#e08941', title: 'Ciência Computacional', iconAlreadyBackground: true },
              { name: 'Breathe', icon: require('../../assets/logo/01/6.webp'), color: '#1f2bb1', title: 'Transformação Digital', iconAlreadyBackground: true },
             ]}
           />
      </div>
      
      <div className="screensaver-content">
       
        <div className="hero__content">
          <h1 className="screensaver-title">
            Centro de Soluções de<br/>
            Baixo Carbono da COPPE
          </h1>
          
          <h4 className="screensaver-subtitle">
            Transformação digital, Inteligência Artificial, Robótica, Manufatura auxiliada <br/> por computador e ciência computacional e engenharia.
          </h4>
         
          <StarBorder
            as="button"
            className="screensaver-button btn btn-lg"
            color="white"
            speed="7s"
            thickness={0.5}
            onClick={handleStart}
          > Toque Aqui
          </StarBorder>

          
         
        </div>
        <div className='fixed-bottom' style={{"z-index": 1, "pointerEvents": "none"}}>
            <ProfileCards />
        </div>
      </div>
      
      
      
    </div>
  );
};

export default ScreenSaver3;
